import React from 'react';
import { ShieldCheck, ScrollText, Users, Clock } from 'lucide-react';
const POINTS = [{
  icon: ShieldCheck,
  title: 'Advice, not just paperwork',
  body: 'A qualified solicitor reviews your matter, so questions of legal risk are answered properly rather than passed on.'
}, {
  icon: ScrollText,
  title: 'Clear scope and fee upfront',
  body: 'You receive the proposed scope and fee before any work begins. No surprises once the matter is underway.'
}, {
  icon: Users,
  title: 'One point of contact',
  body: 'You deal with the team handling your file directly, from first contact through to settlement.'
}, {
  icon: Clock,
  title: 'Deadline aware',
  body: 'Tell us about any auction, offer or signing date and the team assesses how quickly the matter needs to move.'
}];
export function WhyLawyerLed() {
  return <section className="px-5 md:px-6 py-10 md:py-14 bg-background" data-id="element-538" data-mp="2hqp9dg89588">
      <div className="max-w-7xl mx-auto" data-id="element-539" data-mp="7dxrav5i5wkw">
        <div className="max-w-2xl mb-6 md:mb-8" data-id="element-540" data-mp="2fv6zqiwh0f03">
          <p className="eyebrow text-brand-blue mb-1" data-id="element-541" data-mp="2ftvyapqhzjc5">
            why lawyer-led
          </p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-542" data-mp="2btc0rl20idph">
            Legal guidance, not just paperwork.
          </h2>
          <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-543" data-mp="2kute4vo1c1ah">
            Both lawyers and licensed conveyancers can manage conveyancing work.
            A property lawyer can also advise when a transaction becomes more
            complex, so you are covered if something unexpected appears.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-544" data-mp="26vu0ej2296t3">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="h-full flex flex-col rounded-2xl bg-surface border border-border p-5" data-id="element-545" data-mp="1eehmzejmrjoe">
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-brand-blue-light text-brand-blue mb-4" data-id="element-546" data-mp="19f4r64as729o">
                  <Icon className="w-6 h-6" data-id="element-547" data-mp="3egh9bl8ztr4t" />
                </span>
                <h3 className="font-serif text-xl text-ink" data-id="element-548" data-mp="3eemjbsiv78tv">{point.title}</h3>
                <p className="mt-2 text-sm text-muted-ink leading-relaxed" data-id="element-549" data-mp="3j7z9w873tpp9">
                  {point.body}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}